<template>
  <CityCodeConfig />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
